import styled from 'styled-components'
import Text from 'components/shared/Text'

interface RoomTileBadgeProps {
    textColor?: string
    backgroundColor?: string
}

export const RoomTileBadge = styled(Text)<RoomTileBadgeProps>`
    padding: 6px;
    margin-top: 2px;
    margin-bottom: 2px;
    color: ${({ textColor, theme }) => textColor ?? theme.colors.secondary_500};
    background-color: ${({ backgroundColor, theme }) =>
        backgroundColor ?? theme.colors.secondary_100};
    border-radius: 8px;
`
